export default __webpack_public_path__ + "static/media/ReleaseNotes_Phone_Number.c44dea6f.png";